const SectionRight = (props) => {
    return (
        <div
            className="sectionContainer-rightRail contentAreaWrap"
            data-testid="section-right"
        >
            <div className="sidebar contentArea">{props.children}</div>
        </div>
    );
};

export default SectionRight;
